import { render, staticRenderFns } from "./ProductoPrecioPorcentajeForm.vue?vue&type=template&id=a7578352"
import script from "./ProductoPrecioPorcentajeForm.vue?vue&type=script&lang=js"
export * from "./ProductoPrecioPorcentajeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports